<template>
  <!-- พับได้แบบเดียวกับ Workflow / Model Setting / Chat Setting ใน ModelManagement.vue -->
  <div>
    <v-row class="mt-4" v-if="!panelOpen" @click="panelOpen = true">
      <v-col cols="12" sm="12">
        <div class="workflow-panel-body">
          <div class="d-flex align-center justify-start gap-2">
            <img src="@/assets/icon-excute-red.svg" alt="img" width="20" height="20" />
            <span class="header" style="font-size: 18px">{{ $t("_ExecuteTestRuns") }}</span>
            <v-chip v-if="totalTable > 0" class="ms-2" color="#c32e0e" variant="tonal" size="small">{{ totalTable }}</v-chip>
          </div>
          <button type="button" class="workflow-right">
            <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
          </button>
        </div>
      </v-col>
    </v-row>

    <v-card class="card2 mt-8" v-if="panelOpen">
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center justify-start gap-2">
          <img src="@/assets/icon-excute-red.svg" alt="img" width="20" height="20" />
          <span class="header">{{ $t("_ExecuteTestRuns") }}</span>
          <v-chip v-if="totalTable > 0" class="ms-2" color="#c32e0e" variant="tonal" size="small">{{ totalTable }}</v-chip>
        </div>
        <div class="mt-2">
          <button type="button" @click="panelOpen = false">
            <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
          </button>
        </div>
      </div>

      <div class="mt-2">
        <hr />
      </div>

      <!-- ค้นด้วยชื่อการทดสอบ ใช้ markup/สไตล์ชุดเดียวกับช่องค้นหาในเมนู /ValidationProcess -->
      <v-row no-gutters justify="end" class="mt-3 mb-1">
        <div class="custom-search-input-wrapper">
          <div class="custom-search-input-container">
            <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
            <input
              id="testname-field-search-modelvalidationruns"
              type="text"
              :placeholder="$t('testName')"
              :aria-label="$t('testName')"
              class="custom-search-input"
              v-model="searchName"
              @keydown.enter="Search"
            />
            <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'" @click="ClearSearch">
              mdi-close-circle
            </v-icon>
          </div>
        </div>
      </v-row>

      <!-- run ผูกกับ ModelDisplay ซึ่งใช้ร่วมกันทุกเวอร์ชันของโมเดลเดียวกัน
           ตารางนี้จึงเป็นของ "โมเดล" ไม่ใช่ของเวอร์ชันที่เปิดอยู่ -->
      <v-data-table-server
        class="runs-table"
        fixed-header
        :items-per-page="options.itemsPerPage"
        :items-length="searchTotalTable"
        v-model:options="options"
        :items="dataTable"
        :headers="headers"
        :loading="loadingTable"
      >
        <template v-slot:no-data>
          <div class="text-center py-4 empty-text">
            {{ searchName ? $t("_searchNotFound", { name: searchName }) : $t("_noTestRunsForModel") }}
          </div>
        </template>

        <template v-slot:item="{ item }">
          <tr>
            <td style="text-align: left">
              <span class="table-cell-text" :title="item.name">{{ item.name }}</span>
            </td>
            <td style="text-align: left">
              <v-chip v-if="item.questionType" :color="getQuestionTypeColor(item.questionType)" variant="tonal" size="small" class="meta-chip">
                {{ getQuestionTypeText(item.questionType) }}
              </v-chip>
              <span v-else>-</span>
            </td>
            <td style="text-align: left">
              <v-chip :color="getProcessStatusColor(item)" variant="flat" size="small">
                <v-icon start size="14">{{ getProcessStatusIcon(item) }}</v-icon>
                <span>{{ getProcessStatusText(item) }}</span>
              </v-chip>
            </td>
            <td style="text-align: left">{{ item.processingDate }}</td>
          </tr>
        </template>

        <template v-slot:bottom>
          <div class="d-flex justify-space-between align-center px-2 py-2" style="width: 100%">
            <span class="total-text">{{ $t("totalResults") }} {{ searchTotalTable }}</span>
            <v-data-table-footer
              :items-per-page-options="itemsPerPageOptions"
              v-model:items-per-page="options.itemsPerPage"
              v-model:page="options.page"
              :length="pageCount"
            />
          </div>
        </template>
      </v-data-table-server>
    </v-card>
  </div>
</template>

<script>
import validationRunStatusMixin from '@/mixins/validationRunStatusMixin';

export default {
  name: 'ModelValidationRuns',
  mixins: [validationRunStatusMixin],
  props: {
    // GPTModel.ModelID ที่เข้ารหัสไว้ ค่าเดียวกับ $route.query.id ของหน้า /GPTModelDetail
    modelId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      panelOpen: false,
      loadingTable: false,
      dataTable: [],
      searchName: '',
      // แยก total ของหน้าปัจจุบัน (ใช้กับ pagination) ออกจาก total ตอนโหลดครั้งแรก (ใช้กับ chip บนหัวการ์ด)
      // ไม่งั้นพอผู้ใช้ค้นหา ตัวเลขบนหัวการ์ดจะเปลี่ยนตามผลค้นหาแทนที่จะบอกจำนวน run ทั้งหมดของโมเดล
      searchTotalTable: 0,
      totalTable: 0,
      isFirst: true,
      isSearch: false,
      // ลำดับ request กัน response เก่ามาวาดทับของใหม่ ตอนพิมพ์ค้นหาหรือเปลี่ยนหน้าเร็ว ๆ
      tableReqSeq: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  computed: {
    headers() {
      // sortable: false ทุกคอลัมน์ เพราะ backend เรียงคงที่เป็นใหม่สุดขึ้นก่อน
      // และ Question Type / Process Status ไม่ได้เก็บเป็นคอลัมน์เดียวใน DB จึงเรียงตามที่เห็นไม่ได้
      return [
        { title: this.$t('testName'), align: 'left', sortable: false },
        { title: this.$t('questionType'), align: 'left', sortable: false },
        { title: this.$t('processStatus'), align: 'left', sortable: false },
        { title: this.$t('dataProcessed'), align: 'left', sortable: false },
      ];
    },
    pageCount() {
      if (!this.options.itemsPerPage || this.options.itemsPerPage < 1) return 0;
      return Math.ceil(this.searchTotalTable / this.options.itemsPerPage);
    },
    itemsPerPageOptions() {
      return [
        { title: '10', value: 10 },
        { title: '20', value: 20 },
        { title: '50', value: 50 },
        { title: '100', value: 100 },
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    // ไม่ใส่ immediate เพราะ watcher ของ options ยิงนัดแรกให้แล้ว ถ้าใส่จะยิงซ้ำสองรอบ
    modelId() {
      this.isFirst = true;
      this.options.page = 1;
      this.Get();
    },
  },
  methods: {
    Search() {
      this.isSearch = true;
      this.Get();
    },
    ClearSearch() {
      if (!this.searchName) return;
      this.searchName = '';
      this.Search();
    },
    Get() {
      if (!this.modelId) {
        this.dataTable = [];
        this.searchTotalTable = 0;
        this.totalTable = 0;
        return;
      }

      this.loadingTable = true;
      const myReq = ++this.tableReqSeq;
      const { page, itemsPerPage } = this.options;

      const temp = {
        modelId: this.modelId,
        name: this.searchName,
        // กดค้นหาแล้วต้องกลับไปหน้า 1 ไม่งั้นค้างอยู่หน้าที่เกินจำนวนผลลัพธ์ใหม่แล้วได้ตารางว่าง
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage,
      };

      this.$call.GetValidationProcessByModel(
        temp,
        (dataResponse) => {
          // มี request ที่ใหม่กว่าออกไปแล้ว → ทิ้ง response นี้
          if (myReq !== this.tableReqSeq) return;
          if (dataResponse.status == 0 && dataResponse.data) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data ?? [];
            this.totalTable = this.isFirst ? dataResponse.data.total : this.totalTable;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
          }
          if (this.isSearch) {
            this.options.page = 1;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          if (myReq !== this.tableReqSeq) return;
          // panel นี้เป็นข้อมูลประกอบ ไม่ใช่ข้อมูลหลักของหน้า ถ้าโหลดไม่ได้ให้เงียบ
          // แล้วโชว์ empty state แทนการเด้ง error ทับฟอร์มที่ผู้ใช้กำลังแก้อยู่
          console.error(errorResource);
          this.dataTable = [];
          this.searchTotalTable = 0;
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.workflow-panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px !important;
  border-radius: 10px;
  background: linear-gradient(100deg, #fff2f2 0%, #ffded8 100%) !important;
  cursor: pointer;
}

.workflow-right {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card2 {
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  padding: 20px 10px !important;
  box-shadow: none !important;
}

.header {
  font-weight: 700;
}

/* จำกัดความสูงของ "ตัวตาราง" ไม่ใช่ทั้งการ์ด เพื่อให้ fixed-header ของ Vuetify
   มี scroll container ที่ถูกต้อง หัวคอลัมน์จึงค้างอยู่กับที่ตอนเลื่อนดูแถว
   ใช้ max-height ไม่ใช่ prop height เพื่อให้ตารางหดตามจำนวนแถวเมื่อมีน้อยกว่าเต็มหน้า */
.runs-table :deep(.v-table__wrapper) {
  max-height: 340px;
  overflow-y: auto;
}

.runs-table :deep(th) {
  font-weight: 600 !important;
  white-space: nowrap;
}

/* ชื่อการทดสอบยาวได้ จึงตัดด้วย ellipsis แล้วให้ดูเต็มจาก title */
.table-cell-text {
  display: inline-block;
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.meta-chip {
  max-width: 180px;
  font-weight: 500 !important;
}

.empty-text {
  color: #6b7280;
  font-size: 14px;
}

.total-text {
  color: #6b7280;
  font-size: 13px;
  white-space: nowrap;
}
</style>
